module Meevo.Plugins.StandingAppointments {
    export class StepsModal {
        static $inject = [
            '$scope',
            'appointmentBookModalService',
            "meevo.components.common.DataService",
            'serviceSchedule',
            "isReadOnly",
            "client",
            "meevo.plugins.appointmentBook.stepOverrideService"
        ];

        constructor(
            protected $scope,
            protected modal,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected serviceSchedule,
            private isReadOnly,
            private client,
            protected stepOverrideService
        ) {
            this.stepOverrideService.initialize(serviceSchedule, this.client).then(() => {
                $scope.steps = serviceSchedule.steps;
            });

            $scope.modal = modal;
            $scope.isReadOnly = isReadOnly;

            $scope.stepDurationDisabled = () => {
                if (!this.serviceSchedule.service) {
                    return true;
                }
                return this.serviceSchedule.service.doNotAllowStepTimingOverride;
            }

            $scope.closeModal = () => {
                this.modal.hideModal('close');
            }

            $scope.saveModal = () => {
                this.modal.hideModal().then(() => {
                    this.stepOverrideService.check(this.serviceSchedule, this.client);
                });
            }
        }
    }

    angular.module("meevo.plugins.standingAppointments")
        .controller("meevo.plugins.standingAppointments.StepsModalController", StepsModal);
}